import { Component, Input, ViewEncapsulation } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { Register } from 'src/app/common-components/register/models/register';
import { FilterOperations } from 'src/app/filters/filter-operation/filter-operations.enum';
import { ExtensionRegisterOptions } from '../models/extension-register-options';
import { ExtensionRegisterListItem } from '../models/extension-register-results.model';
import { ExtensionsFilterOption } from '../models/extensions-filter-option';
import { extensionRegisterAdapterActions, extensionRegisterInitialFilter } from '../state/extension-register.actions';
import * as extensionRegisterReducer from '../state/extension-register.reducer';
import { getShowExtensionRegisterPopupUserPreference } from 'src/app/store/user-preferences/user-preferences.selectors';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-location-extension-register',
    styleUrls: [],
    templateUrl: './location-extension-register.component.html',
    standalone: false
})
export class LocationExtensionRegisterComponent extends Register<
   ExtensionRegisterListItem,
   ExtensionRegisterOptions,
   OrderingOption
> {
   @Input() set locationId(value: number) {
      if (value) {
         const filters: ExtensionsFilterOption[] = [
            {
               field: 'LocationId',
               operation: FilterOperations.EqualTo,
               type: 'numeric',
               value: value,
            },
         ];
         this.store.dispatch(extensionRegisterInitialFilter({ filters }));
      }
   }

   showExtensionRegisterPopup$: Observable<boolean>;
   
   entityName = 'Extension';

   columns: string[] = ['name', 'number', 'type', 'extensionsActionsMenu'];

   constructor(public store: Store) {
      super(store, extensionRegisterReducer.selectors, extensionRegisterAdapterActions);
      this.showExtensionRegisterPopup$ = this.store.pipe(
               select(getShowExtensionRegisterPopupUserPreference),
               map((isTooltipsShown) => isTooltipsShown ?? true)
            );
   }
}
